<template>
  <div class="layout-placeholder">
    <div class="placeholder-icon">
      <i class="fa-solid fa-layer-group"></i>
    </div>
    <div class="placeholder-text">
      <p class="text-[18px] font-normal text-gray-700">Компонент макет</p>
      <p class="text-[14px] font-normal text-gray-700">Налаштуйте макет уроку для відображення контенту</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{}>();
</script>

<style scoped>
@reference "tailwindcss";
/* Стилі для заглушки */
.layout-placeholder {
  @apply w-full flex flex-col items-center justify-center min-h-[200px] p-5 text-center transition-all duration-300;
  /* background: linear-gradient(135deg, #ecf3fc 0%, #c3cfe2 100%); */
  border-radius: 12px;
  border: 1px dashed #050505;
  user-select: none;
}

.layout-placeholder:hover {
  /* background: linear-gradient(135deg, #bdc8d5 0%, #b8c6db 100%); */
  border-color: #a0aec0;
  /* transform: translateY(-2px); */
  /* box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1); */
}

.placeholder-icon {
  @apply text-5xl text-gray-500 mb-4 opacity-70;
}

.placeholder-text p {
  @apply m-0 leading-relaxed;
}

/* Адаптивність для мобільних пристроїв */
@media (max-width: 768px) {
  .layout-placeholder {
    @apply min-h-[150px] p-4;
  }
  
  .placeholder-icon {
    @apply text-4xl mb-3;
  }
  
  .placeholder-text h3 {
    @apply text-base mb-1;
  }
  
  .placeholder-text p {
    @apply text-xs;
  }
}
</style>
